export default __webpack_public_path__ + "static/media/SWT0190.34I-27409_-16471_0.4b038563.jpg";